import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { isSuperuser } from "@/features/superuser/is-superuser";

export const Route = createFileRoute("/_authenticated/superuser")({
  beforeLoad: ({ context }) => {
    const { user } = context;

    if (!isSuperuser(user.email)) {
      throw redirect({ to: "/workspaces" });
    }
  },
  component: SuperuserLayout,
});

function SuperuserLayout() {
  return <Outlet />;
}
